import { defineMessages } from 'react-intl'

const scope = `procurify.spending-cards.presenter.ActivatePhysicalCardPresenter`

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Have you received your physical card?',
  },
  activateCardButtonText: {
    id: `${scope}.activateCardButtonText`,
    defaultMessage: 'Activate card',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: `Once activated, your physical card is ready for use. To avoid issues, we recommend waiting until your card arrives before activating it.`,
  },
  activateButton: {
    id: `${scope}.activateButton`,
    defaultMessage: 'Yes, activate card',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  successToastMessage: {
    id: `${scope}.successToastMessage`,
    defaultMessage: 'Card activated',
  },
  errorToastTitle: {
    id: `${scope}.errorToastMessage`,
    defaultMessage: 'Error',
  },
  errorToastMessage: {
    id: `${scope}.errorToastMessage`,
    defaultMessage: 'Could not activate card',
  },
  activeStripeCardErrorToastMessage: {
    id: `${scope}.activeStripeCardErrorToastMessage`,
    defaultMessage: 'Cannot activate Stripe physical card',
  },
})
